import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import ARIcon from './icons/ARIcon';
import { breakpoints } from '../utils/styles';
import { snapchatLensesRoute } from '../routes';

const getButtonColor = (isActive, negative) => {
  if (isActive) return '#FE142F';
  if (negative) return 'white';
  return 'var(--color-text-primary)';
};

const Button = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  padding: 0;
  height: 50px;
  color: ${props => getButtonColor(props.isActive, props.negative)};
  margin-right: 30px;
  
  &:focus,
  &:focus-visible,
  &:active {
    outline: none;
    box-shadow: none;
  }
  
  @media screen and (max-width: ${breakpoints.tablet - 1}px) {
    display: none;
  }
    
  @media screen and (max-width: 1200px) {
    margin-right: 15px;
  }
`;

const ButtonText = styled.span`
  font-size: 16px;
  line-height: 50px;
  letter-spacing: 0px;
  margin-right: 8px;
  
  &::after {
    content: "Realidad Aumentada";
  }
  
  @media screen and (max-width: 1200px) {
    &::after {
      content: "RA";
    }
  }
`;

const SnapchatButton = ({ history, negative, location }) => {
  const handleClick = () => {
    history.push(snapchatLensesRoute);
  };

  return (
    <Button 
      onClick={handleClick} 
      negative={negative} 
      isActive={location.pathname === snapchatLensesRoute}
    >
      <ButtonText />
      <ARIcon width="22" height="22" />
    </Button>
  );
};

export default withRouter(SnapchatButton);